import '../styles/page-pattern-intelligence.css';
import Seo from '../components/Seo';
export default function PatternIntelligencePage() {
  
  return (
    <>
      <Seo title="Pattern Intelligence — Ask TeamGrid & Org Intelligence | TeamGrid™" description="Ask your org anything in plain English and get evidence-backed answers. Pattern Intelligence surfaces rhythms, anomalies and trends across every team, daily." />
<header className="pi-hero" id="ask">
  <div className="container-wide">
    <div className="pi-grid">
      <div>
        <span className="hero-badge">
          <img className="mark" src="/assets/mark-teamgrid.svg" alt="" />
          Org Intelligence + Ask TeamGrid <span className="arr">›</span>
        </span>
        <h1 style={{fontSize: '52px', lineHeight: '57px', letterSpacing: '-2.1px', fontWeight: '700', color: 'var(--ink-hero)', marginBottom: '26px'}}>Ask anything.<br /><span style={{color: '#a9aab3'}}>Your org answers.</span></h1>
        <ul className="hero-checks">
          <li><svg aria-hidden="true" className="chk" viewBox="0 0 16 16"><path fill="none" stroke="#007A6E" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" d="M2 8.5 6 12.5 14 3.5" /></svg><span><b>Pattern analysis.</b> Rhythms, anomalies & trends — detected daily.</span></li>
          <li><svg aria-hidden="true" className="chk" viewBox="0 0 16 16"><path fill="none" stroke="#007A6E" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" d="M2 8.5 6 12.5 14 3.5" /></svg><span><b>Org Intelligence.</b> Every team, one living map of how work flows.</span></li>
          <li><svg aria-hidden="true" className="chk" viewBox="0 0 16 16"><path fill="none" stroke="#007A6E" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" d="M2 8.5 6 12.5 14 3.5" /></svg><span><b>Plain answers.</b> Ask in English, get evidence-backed replies.</span></li>
        </ul>
        <div className="hero-cta-row">
          <a className="btn-primary" href="/register">Try Ask TeamGrid free</a>
          <span className="hero-cta-note">7-day free trial.<br />No credit card.</span>
        </div>
      </div>
      <div>
        <div className="askmock">
          <div className="askmock-top"><img src="/assets/mark-teamgrid.svg" alt="" />Ask TeamGrid<span style={{marginLeft: 'auto', fontSize: '10px', letterSpacing: '1.4px', color: '#e0483d'}}>● LIVE</span></div>
          <div className="askbody">
            <div className="msg user" id="pmUser">Why did support slow down in May?</div>
            <div className="msg ai" id="pmAI">Three patterns explain it: ticket volume rose <b>+18%</b> while two senior agents were on leave, and reply times stretched after a <b>Friday coverage gap</b> appeared.
              <span className="evid">
                <span><i style={{background: '#F2673A'}}></i>Pattern: Friday 2–4 AM coverage gap · since May 3</span>
                <span><i style={{background: '#469FD8'}}></i>Signal: +18% tickets · same headcount</span>
                <span><i style={{background: '#6C59A6'}}></i>HRMS: 2 senior agents on planned leave</span>
              </span>
            </div>
            <div className="followups">
              <span className="fu">Fix the Friday gap</span>
              <span className="fu">Who carried the load?</span>
              <span className="fu">Draft a staffing plan</span>
            </div>
          </div>
          <div className="askinput">⌕{'\u00a0'}<span id="askType2" style={{color: 'var(--ink-strong)', fontWeight: '600'}}></span><span className="caret"></span></div>
        </div>
      </div>
    </div>
  </div>
</header>




<section className="sect" style={{paddingTop: '24px'}}>
  <div className="container">
    <h2 className="sect-h2">The patterns were always there.<br /><span className="dim">Now you can see them.</span></h2>
    <p className="sect-sub">Four ways Pattern Intelligence turns raw workday signal into decisions.</p>

    
    <div className="frow">
      <div className="fr-copy">
        <span className="fl" style={{color: '#F2673A'}}>ANOMALY FEED</span>
        <h3>Catch the every-7th-day pattern</h3>
        <p className="fd">Leave requests that always land before deadlines. Reply lag that creeps up two weeks before a resignation. TeamGrid flags the rhythm the day it forms — not months later.</p>
        <ul className="fpts">
          <li><span className="sarr">→</span>Attendance & leave rhythms, decoded</li>
          <li><span className="sarr">→</span>After-hours creep & burnout risk scoring</li>
          <li><span className="sarr">→</span>One-click actions on every flag</li>
        </ul>
      </div>
      <div className="frame">
        <div className="frame-h"><span className="dots"><span style={{background: '#ff5f57'}}></span><span style={{background: '#febc2e'}}></span><span style={{background: '#28c840'}}></span></span>ANOMALY FEED — TODAY</div>
        <div className="anlist">
          <div className="ancard"><span className="aico" style={{background: '#fdf1e8'}}><svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24"><path d="M12 4l9 15.5H3z" fill="none" stroke="#F2673A" strokeWidth="2.2" strokeLinejoin="round" /><path d="M12 10v4.5" stroke="#F2673A" strokeWidth="2.2" strokeLinecap="round" /></svg></span><span><span className="at" style={{color: '#F2673A'}}>LEAVE PATTERN</span><span className="am"><b>Rohan</b> — request lands every 7th working day, 6 weeks running</span></span></div>
          <div className="ancard"><span className="aico" style={{background: '#fdece8'}}><svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24"><circle cx="12" cy="12" r="8.5" fill="none" stroke="#e0483d" strokeWidth="2.2" /><path d="M12 7.5V12l3 2" stroke="#e0483d" strokeWidth="2.2" fill="none" strokeLinecap="round" /></svg></span><span><span className="at" style={{color: '#e0483d'}}>AFTER-HOURS</span><span className="am"><b>Marketing</b> — 3× baseline for 12 days · burnout risk rising</span></span></div>
          <div className="ancard"><span className="aico" style={{background: '#eaf2fb'}}><svg aria-hidden="true" width="16" height="16" viewBox="0 0 24 24"><rect x="3.5" y="5.5" width="17" height="13" rx="2.5" fill="none" stroke="#366EB6" strokeWidth="2.2" /><path d="M4.5 8l7.5 5 7.5-5" stroke="#366EB6" strokeWidth="2.2" fill="none" /></svg></span><span><span className="at" style={{color: '#366EB6'}}>REPLY LAG</span><span className="am"><b>Priya</b> — client emails waiting 3+ days, second week in a row</span></span></div>
        </div>
      </div>
    </div>

    
    <div className="frow rev" id="org-intelligence">
      <div className="frame">
        <div className="frame-h"><span className="dots"><span style={{background: '#ff5f57'}}></span><span style={{background: '#febc2e'}}></span><span style={{background: '#28c840'}}></span></span>ORG GRAPH — LIVE</div>
        <div className="oggraph" id="ogGraph">
          <span className="oglink" style={{left: '24%', top: '34%', width: '24%', transform: 'rotate(24deg)'}}></span>
          <span className="oglink" style={{left: '47%', top: '47%', width: '20%', transform: 'rotate(-18deg)'}}></span>
          <span className="oglink" style={{left: '28%', top: '38%', width: '19%', transform: 'rotate(78deg)'}}></span>
          <span className="oglink" style={{left: '50%', top: '50%', width: '22%', transform: 'rotate(52deg)'}}></span>
          <span className="ognode" style={{left: '16%', top: '22%', width: '58px', height: '58px', background: '#2DBDB8', fontSize: '13px'}}>ENG</span>
          <span className="ognode" style={{left: '44%', top: '40%', width: '72px', height: '72px', background: '#366EB6', fontSize: '14px', animationDelay: '.8s'}}>CORE</span>
          <span className="ognode" style={{left: '70%', top: '24%', width: '52px', height: '52px', background: '#6C59A6', fontSize: '12px', animationDelay: '.4s'}}>HR</span>
          <span className="ognode" style={{left: '24%', top: '64%', width: '52px', height: '52px', background: '#F2673A', fontSize: '12px', animationDelay: '1.2s'}}>SALES</span>
          <span className="ognode" style={{left: '68%', top: '62%', width: '56px', height: '56px', background: '#34A851', fontSize: '12px', animationDelay: '1.6s'}}>SUP</span>
          <span className="oglabel" style={{left: '12%', top: '12%'}}>deep-focus +14%</span>
          <span className="oglabel" style={{right: '6%', top: '44%'}}>comms healthy</span>
          <span className="oglabel" style={{left: '40%', bottom: '8%'}}>load: balanced</span>
        </div>
      </div>
      <div className="fr-copy">
        <span className="fl" style={{color: '#366EB6'}}>ORG INTELLIGENCE</span>
        <h3>A living map of how work flows</h3>
        <p className="fd">Teams, hand-offs, load and energy — one graph that updates itself from real activity. Spot the overloaded node before it becomes the bottleneck.</p>
        <ul className="fpts">
          <li><span className="sarr">→</span>Cross-team dependency & load view</li>
          <li><span className="sarr">→</span>Engagement radar per team, per week</li>
          <li><span className="sarr">→</span>Drill from company → team → person patterns</li>
        </ul>
      </div>
    </div>

    
    <div className="frow">
      <div className="fr-copy">
        <span className="fl" style={{color: '#6C59A6'}}>FOUNDER'S REPORT</span>
        <h3>Monday, 9:00 — the whole company in one brief</h3>
        <p className="fd">Wins, risks, and the week ahead — written by AI from your org's actual patterns, not from status meetings. The first email leaders read.</p>
        <ul className="fpts">
          <li><span className="sarr">→</span>Auto-written weekly & monthly briefs</li>
          <li><span className="sarr">→</span>Every claim linked to its pattern</li>
          <li><span className="sarr">→</span>Delivered to email, Slack, or in-app</li>
        </ul>
      </div>
      <div className="frame">
        <div className="frame-h"><span className="dots"><span style={{background: '#ff5f57'}}></span><span style={{background: '#febc2e'}}></span><span style={{background: '#28c840'}}></span></span>FOUNDER'S REPORT — MON 9:00</div>
        <div className="repmock">
          <div className="rp-h">WEEK OF JUL 6</div>
          <div className="rp-t">5 wins · 3 risks · 2 decisions needed</div>
          <div className="bar"><i style={{'--w': '72%', background: '#2DBDB8'}}></i></div>
          <div className="bar"><i style={{'--w': '48%', background: '#469FD8'}}></i></div>
          <div className="bar"><i style={{'--w': '84%', background: '#6C59A6'}}></i></div>
          <div className="bar"><i style={{'--w': '36%', background: '#F2673A'}}></i></div>
          <div className="rp-tags">
            <span style={{background: '#e9f6f0', color: '#1d7a43'}}>Sales +18%</span>
            <span style={{background: '#fdece8', color: '#b43a18'}}>2 burnout risks</span>
            <span style={{background: '#eaf2fb', color: '#2c66a8'}}>Focus +6%</span>
            <span style={{background: '#f4f0fb', color: '#5d49a0'}}>Hiring on track</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>


<section className="sect" style={{paddingTop: '8px'}}>
  <div className="container">
    <div className="roi-cards" style={{marginTop: '0'}}>
      <div className="roi-card"><div className="rl">PATTERNS / WEEK</div><div className="rv">120+</div><p>Rhythms, anomalies and trends surfaced across a typical org.</p></div>
      <div className="roi-card"><div className="rl">FIRST PATTERN</div><div className="rv">24h</div><p>From install to your first meaningful org pattern on screen.</p></div>
      <div className="roi-card"><div className="rl">STATUS MEETINGS</div><div className="rv">−38%</div><p>Replaced by evidence-backed answers from Ask TeamGrid.</p></div>
      <div className="roi-card"><div className="rl">PRIVACY</div><div className="rv">100%</div><p>Patterns, not people. No screenshots, no keystrokes, ever.</p></div>
    </div>
  </div>
</section>


<div className="container"><p className="roi-note" style={{margin: '0 0 4px'}}>*Aggregated, anonymized TeamGrid workspace benchmarks, 2026.</p></div>
<div className="container"><div className="workswith"><span className="wl">WORKS BEST WITH</span><a href="/monitoring">Workforce Analytics →</a><a href="/email-insights">Email Insights →</a></div></div><section className="final" style={{paddingTop: '48px'}}>
  <div className="container-wide">
    <div className="final-band" style={{paddingBottom: '88px'}}>
      <h2>Stop asking around.<br />Start asking TeamGrid.</h2>
      <a className="btn-white" href="/register">Get started FREE</a>
    </div>
  </div>
</section>
    </>
  );
}
